// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AccountModel } from './accountModel.js';
import type { SiteModel } from './siteModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SiteAccountModel {
    'account': AccountModel | null;
    'site': SiteModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SiteAccountModel>> = [
        {
            "name":     "account",
            "baseName": "account",
            "type":     "AccountModel"
        },
        {
            "name":     "site",
            "baseName": "site",
            "type":     "SiteModel"
        },
    ];

    static getAttributeTypeMap() {
        return SiteAccountModel.attributeTypeMap;
    }
}
